module.exports = __webpack_public_path__ + "img/aiwannapaylogo.f6fad975.png";